Application.Forms.ShowBy = {
    ui: {
        element: '.js-show-by',
    },
    classes: {
        active: 'js-show-by_active',
    },
    ready: function () {

        this.bind();

    },
    bind: function(){

        var self = this;

        $(this.ui.element).each(function(){
            // bind
            self.bindElement(this);
            self.bindInput(this);
            // then update
            self.updateElement(this);
        });

    },
    bindElement: function (el) {

        var self = this;

        var $el = $(el);
        var name = $el.data('show-by-control');
        var $trigger = $el.closest('form').find('[name="' + name + '"]');

        $trigger.on('change', function(){
            self.updateElement($el);
        });

    },
    updateElement: function(el){

        var $el = $(el);
        var name = $el.data('show-by-control');
        var value = $el.data('show-by-value');
        var valueNot = $el.data('show-by-value-not');
        var $trigger = $el.closest('form').find('[name="' + name + '"]');

        var passed = true;
        if (!this.isValue($trigger, value) || !this.isValueNot($trigger, valueNot)){
            passed = false;
        }

        // show or hide
        $el.toggleClass(this.classes.active, passed);

        // make sure the transfer value will be triggered
        $el.find('input').trigger('change');


    },
    bindInput: function(el){

        var self = this;

        var $el = $(el);
        var $input = $(el).find('input');

        // get the transfer target input name
        var transferValueToName = $el.data('show-by-transfer-value-to');
        if (!transferValueToName){
            return;
        }

        var $transferValueTo = $el.closest('form').find('[name="' + transferValueToName + '"]');

        $input.on('change', function(){
            if ($el.hasClass(self.classes.active)){
                $transferValueTo.val($(this).val());
                $transferValueTo.trigger('change');
            }
        });

    },
    isValue: function(el, value){
        if (typeof value === 'undefined'){
            return true;
        }
        var values = value.split(',');
        return _.contains(values, $(el).val());
    },
    isValueNot: function(el, value){
        if (typeof value === 'undefined'){
            return true;
        }
        var values = value.split(',');
        return !_.contains(values, $(el).val());
    }
}